export const ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.main-fixed-payments.history-edit');

export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT = Symbol('admin.affiliates.approved.trackers-settings.fixed-payments.history-edit');

export const FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_QUERY = 'affiliate.fixed-tracker-payments-history-changes-item';
export const FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_API_URL = 'admin/history_of_fixed_payments_changes/:itemId/edit';

export const FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_UPDATE_MUTATION = 'affiliate.fixed-tracker-payments-history-changes-item-update';
export const FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_UPDATE_API_URL = 'admin/history_of_fixed_payments_changes/:itemId';
